module.exports = __webpack_public_path__ + "img/login-jveventosdeportivos.9505fdd4.svg";